import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BrandingAndLimitFeatures = ({
  brandingAndLimitFeatures,
  uncategorizedFeatures,
  loading,
  handleClick,
  isCollapsible = false,
  isFreePortal
}) => {
  const HeaderSection = /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "merchCards.businessObjectives.freeToolsRemoveBranding",
      options: {
        freeToolsWithIncreasedLimits: isFreePortal ? /*#__PURE__*/_jsx(Link, {
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.businessObjectives.freeToolsWithLimits"
          })
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.businessObjectives.freeToolsWithLimits"
        })
      }
    })
  });
  const FeaturesListSection = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PriorityFeatures, {
      features: brandingAndLimitFeatures
    }), /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.and"
      })
    }), /*#__PURE__*/_jsx(PriorityFeatures, {
      features: uncategorizedFeatures
    })]
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};